import { IParticipantModel } from 'entities/competitions-b2cr';
import { fromDateToHumanReadableText } from 'shared/helpers/fromDateToHumanReadableText';

export const mapCompetitionParticipantsToRender = (initial: IParticipantModel[]) =>
  initial.map((item) => ({
    user_id: item.user_id ? item.user_id.toString() : '-',
    id: item.id ? item.id.toString() : '-',
    title: item.title ? item.title.toString() : '-',
    competition_id: item.competition_id ? item.competition_id.toString() : '-',
    sales_point_id: item.sales_point_id ? item.sales_point_id.toString() : '-',
    place: item.place ? item.place.toString() : '-',
    purchase_amount: item.purchase_amount ? parseFloat(item.purchase_amount.toString()).toFixed(3).toString() : '-',
    purchase_amount_today: item.purchase_amount_today
      ? parseFloat(item.purchase_amount_today.toString()).toFixed(3).toString()
      : '-',
    created_at: item.created_at ? fromDateToHumanReadableText(item.created_at) : '-',
  }));
